import {
    Stack,
    useColorModeValue,
} from '@chakra-ui/react'

import MobileNavItem from './MobileNavItem'
import { NavItem_t, NavItems_t } from '../../NavBarTypes/NavItem'

export default function MobileNavBar({ navItems }: NavItems_t) {
    return (
        <Stack bg={useColorModeValue('white', 'gray.800')} p={4} display={{ lg: 'none' }} zIndex={9999} position="relative">
            {navItems.map((navItem: NavItem_t) => (
                <MobileNavItem key={navItem.label} {...navItem} />
            ))}
        </Stack>
    )
}

